import { type ProjectProgress } from './ContentProgress.types';

export function isPassedOrWaived(progress: ProjectProgress): boolean {
    return progress.passed === true || progress.waived;
}
